import $ from 'jquery';
import "flexslider";


$(document).ready(function() {
    if ( $('.immoslider').length) {
        var $sliderItemTotal = $(".slider-item-total"),
		$sliderItemCurrent = $(".slider-item-current");

        $('.immoslider').flexslider({
          animation: "slide",
          controlNav: false,
          touch: true,
          slideshow: false,
          start: function(item){
              slideCounter(item);
          },
          after: function(item){
              slideCounter(item);
          }
        });

        function slideCounter(item){
            $sliderItemCurrent.text(item.currentSlide + 1);
            $sliderItemTotal.text(item.count);
        }
      }
}); 



function immolistmap() {
    var map = new google.maps.Map(document.getElementById('immolistmap'), {
      zoom: 13,
      scrollwheel:  false,
      center: new google.maps.LatLng(document.getElementById('immolistmap').getAttribute('data-lng'), document.getElementById('immolistmap').getAttribute('data-lat')),
      fullscreenControl: false,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: 
        [
            {
                "featureType": "administrative",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": "-100"
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 65
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": "50"
                    },
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": "-100"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "lightness": "-13"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "all",
                "stylers": [
                    {
                        "lightness": "20"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "lightness": "-21"
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "all",
                "stylers": [
                    {
                        "lightness": "30"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "hue": "#ffff00"
                    },
                    {
                        "lightness": -25
                    },
                    {
                        "saturation": -97
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "saturation": "-54"
                    },
                    {
                        "lightness": "35"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels",
                "stylers": [
                    {
                        "lightness": -25
                    },
                    {
                        "saturation": -100
                    }
                ]
            }
        ]
    });

    var marker;
    // New Marker
    marker = new google.maps.Marker({
        position: new google.maps.LatLng(document.getElementById('immolistmap').getAttribute('data-lng'), document.getElementById('immolistmap').getAttribute('data-lat')),
        map: immolistmap,
        icon: {
            url: document.getElementById('immolistmapmarker').getAttribute('src'),
            labelOrigin: new google.maps.Point(0, 0)
        },
    });

}
if(document.querySelector("#immolistmap") != null){
    immolistmap();  
}